import type { EventVendorDto } from '@lib/dto/event.dto'
import { VENDOR_SERVICES, VENDOR_SERVICE_LABELS, type VendorService } from '@lib/enums/vendor-service.enum'

/**
 * What a venue can add a company to an event for (docs/planner-vendors.md,
 * decision 25): every service but planning, which has its own slot, and
 * furniture, which a company is on an event for through its rented pieces.
 */
export const ASSIGNABLE_SERVICES: readonly VendorService[] = VENDOR_SERVICES.filter(
  (s) => s !== 'planning' && s !== 'furniture',
)

/** One category of the event's vendors, as the couple reads them. */
export interface VendorCategory {
  label: string
  vendors: EventVendorDto[]
}

/**
 * The event's vendors by category, in the order the services are listed
 * everywhere else. A company here through its rented pieces is under
 * Furniture, and a company on the event two ways is under both.
 */
export function vendorsByCategory(vendors: readonly EventVendorDto[]): VendorCategory[] {
  const serviceOf = (v: EventVendorDto): VendorService => (v.connection === 'rental' ? 'furniture' : v.service)
  return VENDOR_SERVICES.map((service) => ({
    label: VENDOR_SERVICE_LABELS[service],
    vendors: vendors.filter((v) => serviceOf(v) === service),
  })).filter((category) => category.vendors.length > 0)
}
